import { Box, Card, CardActions, CardContent, Typography } from "@mui/material";
import { CardMedia } from "@mui/material/node";

export const FeatureItem = (props) => {
    return (

        <Card sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: { xs: 'stretch', md: 'flex-start' }
        }}>
            {/* <CardHeader
                    title={props.title}
                    subheader={props.subheader}
                    titleTypographyProps={{ align: 'center' }}
                    subheaderTypographyProps={{
                        align: 'center',
                    }}

                /> */}
            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                <CardContent >
                    <Typography component="div" variant="h5" sx={{my:2, px:2}}>
                        {props.title}
                    </Typography>
                    <Typography
                        variant="subtitle1"
                        component="div"
                        sx={{ color: 'text.secondary', px:2 }}
                    >
                        {props.text}
                    </Typography>
                </CardContent>
            </Box>
            <CardMedia component="img"
                sx={{ 
                    width: { xs: '100%', md: '50%' },
                    height: { xs: 250, md: 400 },
                    objectFit: 'cover'
                }}
                image={props.url}
                alt="image" />

            <CardActions>
            </CardActions>
        </Card>
    );
};